import { render } from "./Tag.vue?vue&type=template&id=55d52b4a&scoped=true&ts=true"
import script from "./Tag.vue?vue&type=script&lang=ts"
export * from "./Tag.vue?vue&type=script&lang=ts"

import "./Tag.vue?vue&type=style&index=0&id=55d52b4a&scoped=true&lang=less"

import exportComponent from "D:\\Code\\BranchManageSystem\\UI\\risfond-branchmanagementsystem\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55d52b4a"]])

export default __exports__